export interface FreeBetCondition {
  Condition: number;
  ConditionValueInt: number;
  ConditionValueDecimal: number;
}

export interface FreeBetVoucherHistory {
  ChangeOwnerNodesNr: number;
  ChangeTimestamp: string;
  IsPrinted: boolean;
  Status: number;
}

export interface FreeBetBettingRestrictions {
  RestrictionsByCutPoint: Record<string, unknown>;
}

export interface FreeBetPBSVoucherInfo {
  AdditionalInfos: Record<string, unknown>;
  Amount: number;
  BettingRestrictions: FreeBetBettingRestrictions;
  BonusOfferId: number;
  ChannelNodeTypes?: number[];
  ConfirmationStatus?: number;
  CurrencyISOCode: string;
  FullAmount?: number;
  GeneralConditions: Record<string, unknown>;
  IsPrinted: boolean;
  Status: number;
  UserNodesNr: number;
  VoucherCode: string;
  VoucherHistory: FreeBetVoucherHistory[];
  VoucherStatus: number;
}

export interface FreeBetData {
  Amount: number;
  BonusOfferId: number;
  Conditions: FreeBetCondition[];
  ExpirationDate: string;
  IsRedeemable: boolean;
  IsTerminalVoucher: boolean;
  License: string;
  Name: string;
  PBSVoucherInfo: FreeBetPBSVoucherInfo;
  VoucherCode: string;
}

export interface FreeBetAvailableDepositFb {
  DepositAmount: number;
  FreebetsAmount: number;
  MinOdds: number;
  DateLimit: string;
  StartDate: string;
  ConversionRate: number;
  VoucherMultiplier: number;
  VoucherValue: number;
  GrossWin: number;
  LastGrossWinUpdate: string;
  PromoName: string;
  ValidBets: number;
  MaxBets: number;
  ConditionsUrl: string;
  PromoType: string;
  MaxBonusMultiplier: number;
}

export interface FreeBetAvailableDepositFbFormatted {
  Name: string;
  Type: string;
  GrossWin: number;
  AmountFb: number;
  TotalBets: number;
  minOdd: number;
  AmountBets: number;
  pendingAmount: number;
  date: Date;
  dateStart: string;
  dateGW: number;
  active: string;
  PercentDev: number;
  Url: string;
}

export interface FreeBetResponse {
  data: FreeBetData[];
  availableDepositFbs: FreeBetAvailableDepositFb[];
  success: boolean;
  pendingSms: boolean;
}
